import { Edit3, Eye, PackageMinus, PackagePlus, Trash2, History, QrCode, Copy, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ActionMenu } from '@/components/ui/ActionMenu';
import { CardList } from '@/components/ui/CardList';
import { TablePagination } from '@/components/ui/TablePagination';
import type { InventoryItem } from '../types/inventoryList.types';
import { InventoryStatusBadge } from './inventoryStatus';

interface InventoryMobileCardsProps {
 items: InventoryItem[];
 total: number;
 page: number;
 pageSize: number;
 isLoading: boolean;
 onSelect: (item: InventoryItem) => void;
 onView: (id: string) => void;
 onDelete: (item: InventoryItem) => void;
 onEdit: (id: string) => void;
 canDelete: boolean;
 onPageChange: (page: number) => void;
 onPageSizeChange: (pageSize: number) => void;
}

export function InventoryMobileCards({
 items,
 total,
 page,
 pageSize,
 isLoading,
 onSelect,
 onView,
 onDelete,
 onEdit,
 canDelete,
 onPageChange,
 onPageSizeChange,
}: InventoryMobileCardsProps) {
 const navigate = useNavigate();
 return (
 <div className="space-y-2">
 <CardList
 items={items}
 isLoading={isLoading}
 gridClassName="grid-cols-1 md:grid-cols-2"
 renderCard={(item) => (
 <article key={item.id} className="rounded-md border border-slate-200 bg-white p-3 transition-all hover:border-emerald-200 active:scale-[0.98]" onClick={() => onSelect(item)}>
 <div className="flex gap-3">
 <div className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-md bg-slate-100 text-slate-400">
 <img 
   src={item.thumbnail_url || '/assets/other/img/inventory.png'} 
   alt={item.name} 
   className="h-full w-full object-cover" 
 />
 </div>
 <div className="min-w-0 flex-1 space-y-2">
 <div className="flex items-start justify-between gap-2">
  <div className="min-w-0">
    <p className="truncate text-sm sm:text-base font-medium text-slate-900 leading-none">{item.name}</p>
    <p className="text-xs text-xs text-slate-400 mt-1 tracking-wider">{item.code}</p>
  </div>
 <InventoryStatusBadge status={item.status_code} />
 </div>
  <div className="grid grid-cols-2 gap-4 pt-1 border-t border-slate-50">
    <div>
      <p className="text-xs text-slate-400 tracking-tighter">Tồn hiện tại</p>
      <p className="text-sm font-medium text-slate-900 mt-0.5">{item.current_stock.toLocaleString('vi-VN')} {item.unit}</p>
    </div>
    <div>
      <p className="text-xs text-slate-400 tracking-tighter">Giá trị tồn</p>
      <p className="text-sm font-medium text-emerald-600 mt-0.5">{(item.current_stock * item.unit_price).toLocaleString('vi-VN')} đ</p>
    </div>
  </div>
 </div>
 </div>
 <div className="mt-3 flex items-center justify-between border-t border-slate-50 pt-3" onClick={(event) => event.stopPropagation()}>
 <div className="flex items-center gap-1">
 <span className="text-slate-400 italic">ID: {item.id.slice(0, 8)}</span>
 </div>
        <ActionMenu
          items={[
            { label: 'Xem chi tiết', icon: Eye, onClick: () => onView(item.id) },
            { label: 'Sửa', icon: Edit3, onClick: () => onEdit(item.id) },
            { label: 'Nhập kho', icon: PackagePlus, onClick: () => navigate(`/inventory/requests/new?type=import&itemId=${item.id}`) },
            { label: 'Xuất kho', icon: PackageMinus, onClick: () => navigate(`/inventory/requests/new?type=export&itemId=${item.id}`) },
            { label: 'Nhân bản', icon: Copy, onClick: () => console.log('clone', item.id) },
            { label: 'Khóa', icon: Lock, onClick: () => console.log('lock', item.id) },
            ...(canDelete ? [{ label: 'Xóa', icon: Trash2, destructive: true, onClick: () => onDelete(item) }] : []),
          ]}
        />
 </div>
 </article>
 )}
 />
 <div className="rounded-md border border-slate-200 bg-white p-3">
 <TablePagination
 currentPage={page}
 totalItems={total}
 pageSize={pageSize}
 itemLabel="vật tư "
 onPageChange={onPageChange}
 onPageSizeChange={onPageSizeChange}
 pageSizeOptions={[10, 20, 50]}
 className="flex-1"
 />
 </div>
 </div>
 );
}

